import $ from "jquery";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import useRequiredFields from "../../../../../hooks/useRequiredFields";
import Http from "../../../../Common/Http";
import IsLogin from "../../../../Common/IsLogin";
import Select from "react-select";
import ReactDataTable from "../../../../Common/ReactDataTable";

const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [rmpm, setRmpm] = useState([]);
  const [list, setList] = useState([]);
  const { checkRequiredFields } = useRequiredFields();
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState("");
  const [code, setCode] = useState([]);
  const [planningOptions, setPlanningOptions] = useState([]);
  const [setProducts, setSetProducts] = useState();
  const [item, setItem] = useState(null);
  const [itemList, setItemList] = useState([]);
  const [selection, setSelection] = useState(false);
  const [packagingStore, setPackagingStore] = useState(false);

  // Machines state
  const [machines, setMachines] = useState([]);
  const [availableMachines, setAvailableMachines] = useState({}); // Changed to object to store per row

  const [departments, setDepartments] = useState([
    { id: "", name: "Select a Department" },
    { id: 2, name: "Jigger" },
    { id: 6, name: "Glazing" },
  ]);

  const [selectedDepartment, setSelectedDepartment] = useState({
    id: 2,
    name: "Jigger",
  });

  const [combinedList, setCombinedList] = useState([]);

  // Display error message for a field
  const displayError = (fieldName) => {
    if (error && error[fieldName]) {
      return <div className="text-danger small">{error[fieldName]}</div>;
    }
    return null;
  };

  // Helper function to check if two date ranges overlap
  const doDateRangesOverlap = (start1, end1, start2, end2) => {
    if (!start1 || !end1 || !start2 || !end2) return false;

    const startDate1 = new Date(start1);
    const endDate1 = new Date(end1);
    const startDate2 = new Date(start2);
    const endDate2 = new Date(end2);

    // Check if ranges overlap: start1 <= end2 && start2 <= end1
    return startDate1 <= endDate2 && startDate2 <= endDate1;
  };

  // Get machines that are already assigned to overlapping date ranges
  const getConflictingMachines = (currentRowIndex, startDate, endDate) => {
    const conflictingMachines = new Set();

    combinedList.forEach((item, index) => {
      if (
        index !== currentRowIndex &&
        item.data.machine_id &&
        item.data.start_date &&
        item.data.end_date
      ) {
        if (
          doDateRangesOverlap(
            startDate,
            endDate,
            item.data.start_date,
            item.data.end_date
          )
        ) {
          conflictingMachines.add(item.data.machine_id);
        }
      }
    });

    return conflictingMachines;
  };

  // Handle input changes for form fields
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // Fetch available machines based on date range for specific row
  const fetchAvailableMachines = async (startDate, endDate, rowIndex) => {
    try {
      const response = await Http.get(
        `/available-machines?start_date=${startDate}&end_date=${endDate}`
      );
      const allAvailableMachines = response.data.machines || [];

      // Get machines that are conflicting with other rows
      const conflictingMachines = getConflictingMachines(
        rowIndex,
        startDate,
        endDate
      );

      // Filter out conflicting machines
      const machinesForRow = allAvailableMachines.filter(
        (machine) => !conflictingMachines.has(machine.id.toString())
      );

      // Update available machines for specific row index
      setAvailableMachines((prev) => ({
        ...prev,
        [rowIndex]: machinesForRow,
      }));
    } catch (error) {
      console.error("Error fetching available machines:", error);
      // Fallback to all machines if API fails, but still filter conflicts
      const conflictingMachines = getConflictingMachines(
        rowIndex,
        startDate,
        endDate
      );
      const filteredMachines = machines.filter(
        (machine) => !conflictingMachines.has(machine.id.toString())
      );
      setAvailableMachines((prev) => ({
        ...prev,
        [rowIndex]: filteredMachines,
      }));
    }
  };

  // Get current date and time
  const getCurrentDateInput = () => {
    const dateObj = new Date();
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();
    const shortDate = `${year}-${month}-${day}`;

    setInputs((values) => ({
      ...values,
      ["start_date"]: shortDate,
      ["end_date"]: shortDate,
    }));

    const hours = ("0" + dateObj.getHours()).slice(-2);
    const minutes = ("0" + dateObj.getMinutes()).slice(-2);
    const defaultTime = `${hours}:${minutes}`;

    setInputs((values) => ({ ...values, ["expected_time"]: defaultTime }));
  };

  // Add this new function to filter products by department
  const filterProductsByDepartment = (products) => {
    if (selectedDepartment.name === "Jigger") {
      // Filter to show only Jigger products
      return products.filter(
        (product) =>
          product.product?.department_art?.name === "Jigger" ||
          product.product?.department_art?.id === 2
      );
    }
    // For Glazing or any other department, return all products (no filtering)
    return products;
  };

  const filterProductsByDepartmentName = (products, departmentName) => {
    if (departmentName === "Jigger") {
      // Filter to show only Jigger products
      return products.filter(
        (product) =>
          product.product?.department_art?.name === "Jigger" ||
          product.product?.department_art?.id === 2
      );
    }
    // For Glazing or any other department, return all products (no filtering)
    return products;
  };

  // Handle department change
  const handleDepartmentChange = async (e) => {
    const { name, value } = e.target;
    const selected = departments.find((dept) => dept.id === parseInt(value));
    setSelectedDepartment(selected);
    setInputs((prev) => ({
      ...prev,
      department_id: value,
    }));

    if (name == "department_id" && value == 8) {
      setSelection(true);
      setPackagingStore(false);
    } else if (name == "department_id" && value == 17) {
      setSelection(true);
      setPackagingStore(true);
    } else {
      setPackagingStore(false);
    }

    // Re-call the planning requisition API when department changes
    const currentPlanningId = inputs.planning_id;
    if (currentPlanningId) {
      setLoading(true);
      try {
        const response = await Http.get(
          `/planning-requisition/${currentPlanningId}?production=1&returnOnlyItems=1&department=${selected.name}`
        );
        const setWiseProduct = await Http.get("/set-wise-products");
        setSetProducts(setWiseProduct.data);

        // Filter products based on the newly selected department
        if (response?.data?.length > 0) {
          const filteredProducts = filterProductsByDepartmentName(
            response?.data,
            selected.name
          );
          setRmpm(filteredProducts);
        }
      } catch (error) {
        console.error("Error fetching products for planning:", error);
        Swal.fire(
          "Error!",
          "Failed to fetch products for the selected planning.",
          "error"
        );
      } finally {
        setLoading(false);
      }
    }

    // Clear the combined list when department changes
    setCombinedList([]);
  };

  const [allProducts, setAllProducts] = useState([]);
  // Handle planning change
  const handlePlanningChange = async (planningId) => {
    if (!planningId) return;

    setList([]);
    setInputs((prevInputs) => ({
      ...prevInputs,
      planning_id: planningId,
    }));

    try {
      const response = await Http.get(
        `/planning-requisition/${planningId}?production=1&returnOnlyItems=1&department=${selectedDepartment.name}`
      );
      const setWiseProduct = await Http.get("/set-wise-products");
      setSetProducts(setWiseProduct.data);
      // Re-filter products when department changes
      if (response?.data?.length > 0) {
        const filteredProducts = filterProductsByDepartment(response?.data);
        setRmpm(filteredProducts);
      }
      // setRmpm(response?.data);
    } catch (error) {
      console.error("Error fetching products for planning:", error);
      Swal.fire(
        "Error!",
        "Failed to fetch products for the selected planning.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // Add item to the list
  const addMoreList = async (id) => {
    try {
      const response = await Http.get(`/product-search-planning-wise/${id}`);
      const { product: productData, totals: totalData } = response.data;
      const productExists = combinedList.some(
        (item) =>
          item.type === "product" &&
          item.data.production_work_order_item_id ===
            productData.production_work_order_item_id
      );

      const newItem = {
        type: "product",
        data: {
          ...productData,
          machine_id: "",
          required_qty: 0,
        },
        totals: totalData,
      };

      setCombinedList((prev) => [...prev, newItem]);
    } catch (error) {
      console.error("Error fetching product:", error);
      Swal.fire("Error!", "Failed to add product.", "error");
    }
  };
  console.log(combinedList, "combinedList");
  // Refresh available machines for all rows based on their current date ranges
  const refreshAllAvailableMachines = () => {
    combinedList.forEach((item, index) => {
      if (item.data.start_date && item.data.end_date) {
        fetchAvailableMachines(item.data.start_date, item.data.end_date, index);
      }
    });
  };

  // Validate if selecting a machine would create a conflict
  const validateMachineSelection = (
    rowIndex,
    machineId,
    startDate,
    endDate
  ) => {
    if (!machineId || !startDate || !endDate) return true;

    const conflictingItems = combinedList.filter((item, index) => {
      if (index === rowIndex) return false;
      if (item.data.machine_id !== machineId) return false;
      if (!item.data.start_date || !item.data.end_date) return false;

      return doDateRangesOverlap(
        startDate,
        endDate,
        item.data.start_date,
        item.data.end_date
      );
    });

    return conflictingItems.length === 0;
  };

  // Update machine selection
  const handleMachineChange = (index, machineId) => {
    const currentItem = combinedList[index];

    // Validate the selection if dates are available
    if (currentItem.data.start_date && currentItem.data.end_date) {
      if (
        !validateMachineSelection(
          index,
          machineId,
          currentItem.data.start_date,
          currentItem.data.end_date
        )
      ) {
        Swal.fire({
          title: "Machine Conflict!",
          text: "This machine is already assigned to another item with overlapping dates. Please select a different machine or adjust the date range.",
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }
    }

    setCombinedList((prev) => {
      const newList = [...prev];
      newList[index].data.machine_id = machineId;
      return newList;
    });

    // Refresh available machines for all rows to reflect the new assignment
    setTimeout(() => {
      refreshAllAvailableMachines();
    }, 100); // Small delay to ensure state is updated
  };

  // Update quantity
  const handleQtyChange = (index, value) => {
    setCombinedList((prev) => {
      const newList = [...prev];
      newList[index].data.required_qty = value;
      return newList;
    });
  };
  const handleStartDateChange = (index, value) => {
    setCombinedList((prev) => {
      const newList = [...prev];
      newList[index].data.start_date = value;
      return newList;
    });

    if (value && combinedList[index].data.end_date) {
      fetchAvailableMachines(value, combinedList[index].data.end_date, index);
      // Also refresh other rows that might be affected by this date change
      setTimeout(() => {
        refreshAllAvailableMachines();
      }, 200);
    }
  };

  const handleEndDateChange = (index, value) => {
    setCombinedList((prev) => {
      const newList = [...prev];
      newList[index].data.end_date = value;
      return newList;
    });

    if (value && combinedList[index].data.start_date) {
      fetchAvailableMachines(combinedList[index].data.start_date, value, index);
      // Also refresh other rows that might be affected by this date change
      setTimeout(() => {
        refreshAllAvailableMachines();
      }, 200);
    }
  };

  // Remove item from list
  const removeList = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setCombinedList((prev) => prev.filter((_, i) => i !== index));
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      }
    });
  };

  // Form submission
  const formSubmit = () => {
    if (checkRequiredFields()) {
      if (selectedDepartment.name === "Jigger") {
        const missingMachine = combinedList.some(
          (item) => !item.data.machine_id
        );
        // if (missingMachine) {
        //   Swal.fire("Error!", "Please select a machine for all items", "error");
        //   return;
        // }
      }
      const items = combinedList.map((item) => ({
        start_date: item.data.start_date,
        end_date: item.data.end_date,
        product_id: item.data.product.id,
        planning_item_id: item.data.id,
        id: item?.data?.id,
        type: item.type,
        production_work_order_item_id:
          item?.data?.production_work_order_item_id,
        product: item?.data?.product,
        shape_id: item?.data?.shape_id,
        required_qty: item.data.required_qty,
        machine_id: item.data.machine_id || null,
      }));

      const formData = {
        ...inputs,
        items: items,
        to_department_art_id: inputs.department_id
          ? parseInt(inputs.department_id)
          : null,
      };

      Http.post("/store-planning-for-jigger-and-glazing", formData)
        .then((res) => {
          navigate("/view-planning-for-jigger", {
            state: { message: res.data.message, type: "success" },
          });
        })
        .catch((e) => {
          setError(e.response?.data?.errors || {});
        });
    }
  };

  // Table columns configuration
  const cols = [
    { field: "product.name", header: "Item" },
    { field: "shape.name", header: "Shape" },
    { field: "production_work_order_item.color.colour_name", header: "Color" },
    {
      field: "production_work_order_item.decoration.code",
      header: "Decoration",
    },
    {
      field: "production_work_order_item.decoration_name",
      header: "Decoration Name",
    },
    { field: "product.department_art.name", header: "Department" },
    { field: "production_work_order.company.name", header: "Company" },
    { field: "production_work_order.receipt_no", header: "Order" },
  ];

  useEffect(() => {
    const fetchCodes = async () => {
      try {
        const res = await Http.get("/planning-image");
        const formattedData = res.data.map((item) => ({
          value: item.id,
          label: item.code,
        }));
        setCode(formattedData);
      } catch (error) {
        console.error("Error fetching codes:", error);
      }
    };

    setInputs((prev) => ({
      ...prev,
      department_id: 2,
    }));

    fetchCodes();
  }, []);

  useEffect(() => {
    setLoading(true);
    $("body").addClass("collapse-menu");

    const fetchData = async () => {
      try {
        const resPlanning = await Http.get(
          "/planning?production=1&returnOnlyItems=1"
        );
        const planningData = resPlanning.data;
        setPlanningOptions(planningData);
        if (planningData.length > 0) {
          const firstPlanning = planningData[0];
          setInputs((prevInputs) => ({
            ...prevInputs,
            planning_id: firstPlanning.id,
          }));
          handlePlanningChange(firstPlanning.id);
        }

        const resRole = await Http.get("/staff-type-check");
        setRole(resRole.data);

        // Fetch all machines for fallback
        const resMachines = await Http.get("/machines");
        setMachines(resMachines.data || []);

        getCurrentDateInput();

        const resInvoiceNo = await Http.get(
          "/last-code-increment-by-one/planning_for_glazing_and_jiggers/receipt_no/SP"
        );
        setInputs((values) => ({
          ...values,
          receipt_no: resInvoiceNo.data,
        }));
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Short Planning</h5>
        </div>
        <div className="am-pagebody row d-flex justify-content-evenly">
          <div className={"card pd-20 pd-sm-40 col-9"}>
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Create Short Planning For {selectedDepartment.name}
            </h6>
            <hr></hr>

            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Short Plan <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="receipt_no"
                      value={inputs.receipt_no || ""}
                      onChange={handleChange}
                      data-required
                    />
                    {displayError("receipt_no")}
                  </div>
                  <div className="col-lg">
                    <label>Department</label>
                    <select
                      className="form-control"
                      name="department_id"
                      value={selectedDepartment.id}
                      onChange={handleDepartmentChange}
                      // disabled
                    >
                      {departments.map((department) => (
                        <option key={department.id} value={department.id}>
                          {department.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg">
                    <label>Planning</label>
                    <select
                      className="form-control"
                      name="planning_id"
                      value={inputs.planning_id || ""}
                      onChange={(e) => handlePlanningChange(e.target.value)}
                    >
                      <option value="">Select Planning</option>
                      {planningOptions.map((planning) => (
                        <option key={planning.id} value={planning.id}>
                          {planning.receipt_no}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="card-solid">
                    <div className="card-header with-border text-center">
                      <h5 className="card-title mb-0">Items in the list</h5>
                    </div>
                    <div className="card-body mt-3 p-0 pt-3">
                      <table className="table table-sm table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Company</th>
                            <th>Date Range</th>
                            {selectedDepartment.name === "Jigger" && (
                              <th>Machine</th>
                            )}
                            <th>Product</th>
                            <th>Shape</th>
                            <th>Decoration</th>
                            <th>Decoration Name</th>
                            <th>Color</th>
                            <th>Qty</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {combinedList.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {item.data.production_work_order?.company
                                  ?.name || "N/A"}{" "}
                                #
                                {item?.data?.production_work_order
                                  ?.receipt_no || "N/A"}
                              </td>
                              <td>
                                <>
                                  <div className="">
                                    <b>
                                      Start Date{" "}
                                      <i className="fa fa-star required"></i>
                                    </b>
                                    <input
                                      type="date"
                                      className="form-control"
                                      name="start_date"
                                      value={item.data.start_date || ""}
                                      onChange={(e) =>
                                        handleStartDateChange(
                                          index,
                                          e.target.value
                                        )
                                      }
                                      data-required
                                    />
                                    {displayError("start_date")}
                                  </div>
                                  <div className="">
                                    <b>
                                      End Date{" "}
                                      <i className="fa fa-star required"></i>
                                    </b>
                                    <input
                                      type="date"
                                      className="form-control"
                                      name="end_date"
                                      value={item.data.end_date || ""}
                                      onChange={(e) =>
                                        handleEndDateChange(
                                          index,
                                          e.target.value
                                        )
                                      }
                                      data-required
                                    />
                                    {displayError("end_date")}
                                  </div>
                                </>
                              </td>
                              {selectedDepartment.name === "Jigger" && (
                                <td>
                                  <select
                                    className="form-control"
                                    value={item.data.machine_id || ""}
                                    onChange={(e) =>
                                      handleMachineChange(index, e.target.value)
                                    }
                                  >
                                    <option value="">Select Machine</option>
                                    {(availableMachines[index] || []).map(
                                      (machine) => {
                                        const isUsed = combinedList.some(
                                          (listItem, idx) =>
                                            idx !== index &&
                                            listItem.data.machine_id ===
                                              machine.id.toString()
                                        );
                                        const isCurrentSelection =
                                          item.data.machine_id ===
                                          machine.id.toString();

                                        return (
                                          <option
                                          key={machine.id}
                                            value={machine.id}
                                            // disabled={isUsed && !isCurrentSelection}
                                          >
                                            {machine.name}
                                            {/* {isUsed && !isCurrentSelection ? " (Already assigned)" : ""} */}
                                          </option>
                                        );
                                      }
                                    )}
                                  </select>
                                </td>
                              )}

                              <td>{item.data.product?.name || "N/A"}</td>
                              <td>{item.data.shape?.name || "N/A"}</td>
                              <td>
                                {item.data.production_work_order_item
                                  ?.decoration?.code || "N/A"}
                              </td>
                              <td>
                                {item.data.production_work_order_item
                                  ?.decoration_name || "N/A"}
                              </td>
                              <td>
                                {item.data.production_work_order_item?.color
                                  ?.colour_name || "N/A"}
                              </td>
                              <td>
                                <input
                                  type="text"
                                  onInput={(e) => {
                                    // Allow digits and one decimal point
                                    e.target.value = e.target.value
                                      .replace(/[^0-9.]/g, "")
                                      .replace(/(\..*)\./g, "$1");
                                  }}
                                  className="form-control"
                                  value={item.data.required_qty || ""}
                                  onChange={(e) =>
                                    handleQtyChange(index, e.target.value)
                                  }
                                />
                              </td>
                              <td>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => removeList(index)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="card pd-20 pd-sm-40 col-3">
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Planning Products
            </h6>
            <hr></hr>
            <ReactDataTable
              cols={cols}
              receiveData={rmpm}
              isLoading={loading}
              actionTemplate={(item) => (
                <td className="text-right">
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => addMoreList(item.id)}
                  >
                    <i className="fa fa-plus"></i>
                  </button>
                </td>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
